<script lang="ts">
	import type { Schedule } from '#lib/schema-extension.js';
	import { asObjectOrUndefined } from '../directus.js';
	import { setAttr } from '@directus/visual-editing';
	import HdNextMatch from '#lib/hockeydata/components/HDNextMatch.svelte';

	let { block }: { block: Schedule } = $props();
</script>

<div
	data-directus={setAttr({
		collection: 'nextMatch',
		item: block.id!!,
		mode: 'modal'
	})}
>
	<HdNextMatch season={asObjectOrUndefined(block.season)} />
</div>
